<template>
  <div class="businesses-pages-content-wrapper">
    <HeroSection :data="heroSection" />
    <BenefitsSection :data="benefitsSection" />
    <VideoSection :data="videoSection" />
    <SolutionSection :data="solutionSection" />
    <BrandsCrouselSection :data="brandsCrouselSection" />
    <ReportSection :data="reportSection" />
    <FormSection :data="formSection" />
    <NewsletterSection :data="newsletterSection" />
  </div>
</template>

<script>
export default {
  name: 'RecyclingOperators',
  metaInfo: {
    title: 'Centrais de triagem',
  },
  components: {
    HeroSection: () =>
      import('@/components/BusinessesPagesComponents/HeroSection.vue'),
    BenefitsSection: () =>
      import('@/components/BusinessesPagesComponents/BenefitsSection.vue'),
    VideoSection: () =>
      import('@/components/BusinessesPagesComponents/VideoSection.vue'),
    SolutionSection: () =>
      import('@/components/BusinessesPagesComponents/SolutionSection.vue'),
    BrandsCrouselSection: () =>
      import('@/components/BusinessesPagesComponents/BrandsCrouselSection.vue'),
    ReportSection: () =>
      import('@/components/BusinessesPagesComponents/ReportSection.vue'),
    FormSection: () =>
      import('@/components/BusinessesPagesComponents/FormSection.vue'),
    NewsletterSection: () =>
      import('@/components/BusinessesPagesComponents/NewsletterSection.vue'),
  },
  data() {
    return {
      heroSection: {
        background: require('@/assets/images/businesses-pages/operators-hero-bg.png'),
        gradient: true,
        title:
          'Faça parte do Programa <span>eu</span>reciclo impacta e seja uma central de triagem parceira!',
        subtitle:
          'Participe do programa de gestão e integração do ecossistema do setor de reciclagem e receba ainda uma <b>renda extra</b> para investir na sua própria operação. O time eu<span>reciclo</span> dará suporte em todas as etapas de desenvolvimento da sua central de triagem.',
        button: {
          text: 'Quero ser parceiro',
          url: '#',
          color: '',
          external_url: false,
          smooth_scroll: true,
        },
      },
      benefitsSection: {
        title: 'Diferenciais <span>eu</span>reciclo',
        benefits: [
          {
            header: {
              icon: require('@/assets/images/businesses-pages/benefit-icon05.png'),
              title: 'Adicionalidade na receita e no volume',
            },
            content: {
              image: require('@/assets/images/businesses-pages/benefit-image05.png'),
              title: 'Adicionalidade na receita e no volume',
              text:
                'A eu<span>reciclo</span> realiza a conexão entre a demanda de marcas que geram embalagens e a oferta de centrais de triagem em todo o Brasil. Os operadores de reciclagem e as organizações de catadores parceiras recebem um pagamento pelo serviço prestado, que poderá ser aplicado na própria realidade com autonomia. Isso permite melhorias nos processos, salários e infraestrutura de toda a operação.',
            },
          },
          {
            header: {
              icon: require('@/assets/images/businesses-pages/benefit-icon06.png'),
              title: 'Conexões, parceria e oportunidade',
            },
            content: {
              image: require('@/assets/images/businesses-pages/benefit-image06.png'),
              title: 'Conexões, parceria e oportunidade',
              text:
                'Ao se tornar um parceiro da solução eu<span>reciclo</span>, sua organização fará parte do Programa eu<span>reciclo</span> impacta, ue conta com uma rede de contatos com mais de 328 centrais de triagem, 7 mil clientes da eu<span>reciclo</span> e todo apoio para o desenvolvimento da sua central de triagem. É uma grande chance de criar novas conexões com importantes atores da cadeia de resíduos, aumentando as possibilidades de trabalhar com novos compradores.',
            },
          },
          {
            header: {
              icon: require('@/assets/images/businesses-pages/benefit-icon07.png'),
              title: 'Suporte, apoio e treinamentos',
            },
            content: {
              image: require('@/assets/images/businesses-pages/benefit-image09.png'),
              title: 'Suporte, apoio e treinamentos',
              text:
                'A equipe de atendimento eu<span>reciclo</span> presta apoio à resolução de dúvidas e realiza <i>onboardings</i> (boas-vindas aos novos operadores) e treinamentos para adequação à procedimentos e diretrizes. Assim, oferecemos uma experiência personalizada para cada central, de acordo com o que você precisa.',
            },
          },
        ],
      },
      videoSection: {
        color: '#EEFBF5',
        thumb: require('@/assets/images/businesses-pages/recyclingoperators-video-thumb.png'),
        title: 'Como se tornar parceiro <span>eu</span>reciclo?',
        text:
          'A nossa parceria pode ser iniciada de forma simples e remota, em três etapas:<br /><br /><b>1º</b> análise de documentos operacionais<br /><b>2º</b> análise de origem e destino do resíduo<br /><b>3º</b> visita técnica de nossa equipe ao local de operação (não obrigatória).<br /><br />Veja abaixo o vídeo completo sobre as fases do processo, além da lista de documentos obrigatórios para ser uma central de triagem homologada pela eu<span>reciclo</span>.',
        videoId: '8GxFL-VKyxM',
        button: {
          text: 'acessar lista de documentos',
          url: '/250b6602d4b5a9262c75472d598d09c8.pdf',
          color: '',
          external_url: false,
        },
      },
      solutionSection: {
        title: 'Impacto já alcançado',
        tabs: [
          {
            header: {
              icon: require('@/assets/images/businesses-pages/solution-icon04.png'),
              title: '+695 mil toneladas',
            },
            content: {
              image: require('@/assets/images/businesses-pages/solution-image04.png'),
              text:
                'Mais de 695 mil toneladas de resíduos pós-consumo foram compensadas até 2022.<br /><br />Com a parceria de centenas de centrais de triagem em todo o país, conseguimos comprovar que o equivalente a 695 mil carros populares tiveram uma destinação correta após a coleta e separação dos materiais recicláveis.',
            },
          },
          {
            header: {
              icon: require('@/assets/images/businesses-pages/solution-icon05.png'),
              title: '+R$ 41 milhões',
            },
            content: {
              image: require('@/assets/images/businesses-pages/solution-image05.png'),
              text:
                'Uma das etapas fundamentais da parceria eu<span>reciclo</span> é o pagamento pelos serviços prestados pelas centrais de triagem.<br /><br />Desde o início da atuação até 2022, os operadores foram remunerados com mais de R$41,5 milhões de reais. Os valores foram utilizados em treinamentos, equipamentos, estrutura e salários.',
            },
          },
          {
            header: {
              icon: require('@/assets/images/businesses-pages/solution-icon06.png'),
              title: '+ 328 parceiros',
            },
            content: {
              image: require('@/assets/images/businesses-pages/solution-image06.png'),
              text:
                'A eu<span>reciclo</span> é parceira de mais de 328 centrais de triagem, em todas as regiões do país.<br /><br />Dessa forma, nossa rede de parceiros recebe a remuneração pelo serviço prestado e incentivamos a valorização e formalização dos agentes de reciclagem em todo o Brasil.',
            },
          },
        ],
      },
      brandsCrouselSection: {
        color: '#F6FAF5',
        background: require('@/assets/images/businesses-pages/brandscarousel-bg.png'),
        title:
          'Já são mais de <span>328 centrais de triagem homologadas</span> no Programa <span class="not-green">eu</span>reciclo impacta!',
        brands: [
          {
            image: require('@/assets/images/businesses-pages/operator-brand01.png'),
            title: 'COOPCAMATE',
          },
          {
            image: require('@/assets/images/businesses-pages/operator-brand02.png'),
            title: 'Copervai',
          },
          {
            image: require('@/assets/images/businesses-pages/operator-brand03.png'),
            title: 'LF Gestão de Resíduos',
          },
          {
            image: require('@/assets/images/businesses-pages/operator-brand04.png'),
            title: 'MASSFIX',
          },
          {
            image: require('@/assets/images/businesses-pages/operator-brand05.png'),
            title: 'PEP',
          },
          {
            image: require('@/assets/images/businesses-pages/operator-brand06.png'),
            title: 'PLASMAC',
          },
        ],
      },
      reportSection: {
        title: 'Estruturação na prática para a cadeia de reciclagem',
        description:
          'O Relatório de Desempenho da eu<span>reciclo</span>de 2022 revela a nossa evolução e impacto através do investimento na cadeia de reciclagem do país. Em apenas um ano, mais de 329 mil toneladas de resíduos foram destinadas corretamente, um crescimento de 65% em relação ao ano anterior. Conheça a nossa história e parceiros que contribuíram com os resultados obtidos nos três pilares de atuação - social, ambiental e econômico.',
        image: require('@/assets/images/businesses-pages/report-section-image02.png'),
        button: {
          text: 'Acessar relatório',
          url: '/relatorio-de-desempenho',
          color: '',
          external_url: false,
        },
      },
      formSection: {
        title: 'Receba um contato para ser um operador parceiro',
        subtitle:
          'Fale conosco e descubra como adquirir o selo eu<span>reciclo</span> para sua empresa.<br /><br />Solicite um contato da eu<span>reciclo</span> para tirar suas dúvidas sobre como ser um parceiro da nossa solução.',
        id: '981c797d-a20d-4e06-85eb-878e659f020c',
      },
      newsletterSection: {
        title: 'Cadastre-se e receba nossos conteúdos!',
      },
    };
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'
</style>
